module.exports = __webpack_public_path__ + "static/img/logopng.d7f05636.png";